import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import { auth, usersCollection } from './firebaseConfig.js';

// handle page reload
auth.onAuthStateChanged(user => {
  if (user) {
    auth.currentUser.getIdTokenResult().then(result => {
      store.commit('setOwner', result.claims.owner);
      store.commit('setAdmin', result.claims.admin);
    });
    store.commit('setCurrentUser', user);
    store.dispatch('getUserInfo', user.uid);
  }
});

const store = new Vuex.Store({
  state: {
    currentUser: null,
    currentUserInfo: null,
    isOwner: false,
    isAdmin: false,
    currentLocation: null,
    currentLocationImage: null,
    snackbar: {
      enabled: false,
      content: {
        text: '',
        color: 'error'
      }
    }
  },
  mutations: {
    setCurrentUser(state, val) {
      state.currentUser = val;
    },
    setCurrentUserInfo(state, val) {
      state.currentUserInfo = val;
    },
    setOwner(state, val) {
      state.isOwner = val;
    },
    setAdmin(state, val) {
      state.isAdmin = val;
    },
    setCurrentLocation(state, val) {
      state.currentLocation = val;
    },
    setCurrentLocationImage(state, val) {
      state.currentLocationImage = val;
    },
    snackbarEnabled(state, val) {
      state.snackbar.enabled = val;
    },
    setSnackbarContent(state, val) {
      state.snackbar.content = val;
    }
  },
  actions: {
    clearData({ commit }) {
      commit('setCurrentUser', null);
    },
    createSnackbar({ commit }, value) {
      commit('setSnackbarContent', value);
      commit('snackbarEnabled', true);
    },
    getUserInfo({ dispatch, commit }, id) {
      return usersCollection
        .doc(id)
        .get()
        .then(res => {
          let data = res.data();
          data.id = id;
          commit('setCurrentUserInfo', data);
        })
        .catch(() => {
          dispatch('createSnackbar', {
            color: 'error',
            text: `Error loading user info`
          });
        });
    }
  }
});

export default store;
